export default __webpack_public_path__ + "static/media/CRM-HOME-2.4991a4f5.png";